import React from 'react';
import {Button, Link, IconButton} from "@material-ui/core"
import { PictureAsPdf } from "@material-ui/icons";
import InvoyageTooltip from './InvoyageTooltip'; // Adjust import path as needed




const TOOLTIP_TEXTS = {
  extract: "Runs the selected configuration on this bill",
  rebuildMetadata: "Clears all metadata, extracts afresh with OCR, and reparses bill with AI",
  parseWithAI: "Send extracted data and customized prompt instructions to build an AI parsing. If the bill is already parsed, the current parsing will be archived and replaced.",
  correctivePass: "Runs a second pass on the same data, good for correcting small common issues in parsing",
  supplementalPass: "Runs a second pass using the raw, complete OCR data. Good for finding data that isn't consistently available in structured data (tables, PDF, queries). Good for extracting or validating items that are in an unusual, unstructured location on the document.",

}

const BillControls = ({
  selectedConfiguration,
  selectedTextractBill,
  snackbar,
  extractBill,
  rebuildFromScratch,
  parseWithGPT,
}) => {
  const PARSING_IN_PROGRESS_REGEX = /Parsing with|Beginning extract|Rebuilding/ig
  const [parsingInProgress, setParsingInProgress] = React.useState(false)
  React.useEffect(_ => {
    if (snackbar && snackbar.message && PARSING_IN_PROGRESS_REGEX.test(snackbar.message)) {
      setParsingInProgress(true)
    } else {
      setParsingInProgress(false)
    }
  },[snackbar.message])
  return (
    <div style={{ display: 'flex', gap: 4 }} className="invoyage-bill-controls">
      <InvoyageTooltip title={TOOLTIP_TEXTS.extract} arrow>
        <span>
          <Button
            variant="contained"
            disabled={!selectedConfiguration || !selectedTextractBill || parsingInProgress}
            onClick={() => extractBill(selectedTextractBill, selectedConfiguration)}
          >
            Extract Bill
          </Button>
        </span>
      </InvoyageTooltip>

      {!!selectedTextractBill.tables &&
        selectedTextractBill.utility_company_id &&
        !selectedTextractBill.status.includes('PROCESSED_') && (
          <>
            <InvoyageTooltip title={TOOLTIP_TEXTS.parseWithAI} arrow>
              <span>
                <Button
                  disabled={parsingInProgress}
                  variant="contained"
                  onClick={() => parseWithGPT(selectedTextractBill)}
                >
                  {!selectedTextractBill.gpt_bill
                    ? 'Parse bill with AI'
                    : 'Redo Initial Parsing'}
                </Button>
              </span>
            </InvoyageTooltip>
            {selectedTextractBill.gpt_bill && (
              <InvoyageTooltip title={TOOLTIP_TEXTS.correctivePass} arrow>
                <span>
                  <Button
                    disabled={parsingInProgress}
                    variant="contained"
                    onClick={() =>
                      parseWithGPT(selectedTextractBill, 'do_second_pass')
                    }
                  >
                    Do Corrective Pass
                  </Button>
                </span>
              </InvoyageTooltip>
            )}
            {selectedTextractBill.gpt_bill && (
              <InvoyageTooltip title={TOOLTIP_TEXTS.supplementalPass} arrow>
                <span>
                  <Button
                    disabled={parsingInProgress}
                    variant="contained"
                    onClick={() =>
                      parseWithGPT(selectedTextractBill, 'do_supplementary_pass')
                    }
                  >
                    Do Supplemental Pass
                  </Button>
                </span>
              </InvoyageTooltip>
            )}
            {!selectedTextractBill.processed &&
              selectedTextractBill.status !== 'UNPROCESSED' && (
                <InvoyageTooltip title={TOOLTIP_TEXTS.rebuildMetadata} arrow>
                  <span>
                    <Button
                      disabled={parsingInProgress}
                      variant="contained"
                      onClick={() => rebuildFromScratch(selectedTextractBill)}
                    >
                      Reset All Metadata and Rebuild
                    </Button>
                  </span>
                </InvoyageTooltip>
              )}
          </>
        )}
      <InvoyageTooltip
        title={
          selectedTextractBill.s3_key &&
          selectedTextractBill.s3_key.split('/').pop()
        }
        arrow
      >
        <Link href={selectedTextractBill.download_url} target="_blank">
          <IconButton color="primary">
            <PictureAsPdf />
          </IconButton>
        </Link>
      </InvoyageTooltip>
    </div>
  );
};

export default BillControls;